import type { ContentPage } from "@/lib/content/types";

// CRM › CRM Analytics › Charts (leaf).
export const charts: ContentPage = {
  slug: "crm-analytics/charts",
  template: "hrmsFeature",
  seo: {
    title: "CRM Charts - Visualize Sales Data | GetBiz CRM",
    description: "Turn CRM data into clear charts and dashboards with GetBiz CRM. Bar, line, pie and funnel charts that surface trends instantly.",
    keywords: ["crm charts", "sales data visualization", "crm dashboard charts", "sales graphs"],
    ogImage: "/assets/data/seoimages/charts.webp",
  },
  leaf: {
    hero: {
      caption: "Charts",
      title: "Visualize Sales Performance at a Glance",
      description: "Turn any report into clear bar, line, pie or funnel charts so trends and outliers jump out instantly.",
      h1: "caption",
    },
    split: {
      title: "Why Teams Choose Charts",
      bullets: [
        { title: "Multiple Chart Types", description: "Bar, line, pie, funnel and more from any report." },
        { title: "Live Dashboards", description: "Combine charts into dashboards that update in real time." },
        { title: "Compare Periods", description: "See growth by comparing this period to the last." },
        { title: "Shareable", description: "Share dashboards with the whole team or leadership." },
      ],
      image: "/assets/images/img/product/crm/charts-lead-image.webp",
      imageAlt: "Charts — GetBiz CRM",
    },
    cardsHeading: {
      title: "Works With the Rest of CRM Analytics",
      description: "Charts connects to every other part of CRM Analytics in GetBiz CRM.",
    },
    cards: [
      { title: "Reports", href: "/crm-software/crm-analytics/reports/", description: "Create, filter and schedule reports on leads, deals, activity and revenue.", image: "/assets/images/img/product/crm/reports.webp", imageAlt: "GetBiz CRM reports" },
      { title: "Cohorts", href: "/crm-software/crm-analytics/cohorts/", description: "Group leads and customers into cohorts to see how conversion, retention and value change across segments and time.", image: "/assets/images/img/product/crm/cohorts.webp", imageAlt: "GetBiz CRM cohorts" },
      { title: "KPIs", href: "/crm-software/crm-analytics/kpis/", description: "Set targets and monitor sales KPIs.", image: "/assets/images/img/product/crm/kpis.webp", imageAlt: "GetBiz CRM kpis" },
      { title: "Funnels", href: "/crm-software/crm-analytics/funnels/", description: "Visualize your pipeline as a funnel to find the stages where deals stall, so you know precisely where to improve.", image: "/assets/images/img/product/crm/Funnels.webp", imageAlt: "GetBiz CRM funnels" },
    ],
    testimonials: {
      title: "Businesses across India love & trust GetBiz!",
      description: "See why teams choose GetBiz CRM to run their sales.",
    },
    bookDemoTitle: "See Charts in action.",
    relatedBlogs: "static",
    metaKey: "crm-analytics-charts",
  },
  sections: [],
};
